export default __webpack_public_path__ + "img/iIPHEfGb.73b8b215.svg";